import type { ComponentProps } from 'react'
import { forwardRef, useId } from 'react'
import * as React from 'react'
import TextInputOnly from './TextInputOnly'
import InputLabelWrap from './InputLabelWrap'

interface Props extends Omit<ComponentProps<typeof TextInputOnly>, 'ref'> {
  label?: React.ReactNode
  optionalIndicatorEnabled?: boolean
  requiredIndicatorEnabled?: boolean
  uppercase?: boolean
}

const TextInput = forwardRef<HTMLInputElement | null, Props>((props, ref) => {
  const {
    className,
    label,
    style,
    optionalIndicatorEnabled,
    requiredIndicatorEnabled,
    hidden,
    id: suppliedId,
    ...inputProps
  } = props
  const generatedId = useId()
  const separateLabel = !!inputProps.action
  const id = suppliedId ?? (separateLabel ? generatedId : undefined)

  return (
    <InputLabelWrap
      label={label}
      separateLabel={separateLabel}
      htmlFor={separateLabel ? id : undefined}
      style={style}
      className={className}
      required={inputProps.required}
      requiredIndicatorEnabled={requiredIndicatorEnabled}
      optionalIndicatorEnabled={optionalIndicatorEnabled}
      hidden={hidden}
    >
      <TextInputOnly {...inputProps} id={id} ref={ref} />
    </InputLabelWrap>
  )
})

TextInput.displayName = 'TextInput'

export default TextInput
